export const FETCH_START = "setLoading";
export const PURGE_AUTH = "logOut";
export const SET_AUTH = "setUser";
export const SET_ERROR = "setError";
export const SET_PROFILE = "setProfile";
export const PURGE_ERROR = "clearError";
export const SET_SESSION = "setSession";
export const SET_CRITERIA_FORM = "setCriteriaForm";
export const SET_Innovations_FORM = "setInnovationsForm";
export const SET_TEAMS = "setTeams";
export const SET_SidebarActive = "setSidebarActive";
export const RESET_STATE = "resetState";
export const SET_SHARED_DATA = "setSharedData"
export const SET_checklist_FORM = "setChecklistForm";
export const SET_STARTUP_APPLICATION = "setStartupApplication";
export const SET_REQUEST_FORM = "setRequestForm";
export const SET_SAVE_MESSAGE = "setSaveMessage";
export const SET_APPLICATION = "setApplication";

export const PURGE_SAVE_MESSAGE = "purgeSaveMessage";
export const REMOVE_SESSION = "removeSession";
export const VERIFY_USER = "verifyUser";
export const PURGE_DRAFT_FORM = "purgeDraftForm";
export const SET_MAIRMenuActive = "setMAIRMenuActive";
export const SET_ApplicationMenuActive = "setApplicationMenuActive";
export const SET_LabelMenuActive = "setLabelMenuActive";
export const SET_HashId = "setHashId";
export const SET_LabelApp = "setLabelApp";
export const SET_STARTUP_INFORMATIONS = "setStartupInformations";
export const SET_APPLICATION_SESSION= "setApplicationSession";
export const SET_START_LEAVE_DATE = "setStartLeaveDate";
export const SET_START_BOURSE_DATE = "setStartBourseDate";
export const SET_END_BOURSE_DATE = "setEndBourseDate";
export const SET_SHOW_APP = "setShowApp";

// Ecosystem mutations
export const SET_FORM_DATA = "setFormData";
export const SET_ECOSYSTEM_MENU_ACTIVE = "setEcosystemMenuActive";
export const SET_ECOSYSTEM_APP = "setEcosystemApp";
export const SET_ECOSYSTEM_APP_MAIR = "setEcosystemAppMair";
export const SET_STRUCTURE_AND_ORGANIZATION = "setStructureAndOrganization"
export const SET_HAS_APPS = "setHasApps"
export const SET_PROGRESS = "setProgress"
export const SET_ECOSYSTEM_TEAM = "setEcosystemTeam"
export const SET_ECOSYSTEM_SESSION = "setEcosystemSession";

// Declarations mutations
export const SET_DECLARATION_FORM = "setDeclarationForm";
